<template>
    <button class="button success"
            type="button"
            @click.stop="addToCart"
    >
        <i class="fas fa-plus"></i>
        <span>{{ buttonText }}</span>
    </button>
</template>

<script>
    export default {
        props: {
            buttonText: {
                required: true,
                type: String
            },
            route: {
                required: true,
                type: String
            },
            productIdProp: {
                required: true,
                type: String
            },
            hasVariationsProduct: {
                required: true,
                type: Boolean
            }
        },

        data() {
            return {
                quantity: 1,
                productId: this.productIdProp,
                optionsAreFilled: false,
                canSendAjax: false,
            }
        },

        mounted() {
            // Ak nemame variacny produkt kontorlu ignorujeme
            if ( !this.hasVariationsProduct ) this.optionsAreFilled = true;

            // reakcia na event ked na inpute s poctom kusov nastane zmena updatne sa quantity
            // v tejto komponente
            this.$root.$on('updateQuantity', data => this.quantity = data);

            // reakcia na event ked sa vyberie variacia produktu
            // upravi sa productId na zaklade vybranej variacii
            this.$root.$on('setProduct', data => this.productId = data.productId);

            // kontrola ci su vsetky moznosti vyplnene inak neni mozne pridat produkt
            this.$root.$on('optionsValidation', data => this.optionsAreFilled = data);
        },

        methods: {
            addToCart() {
                this.$root.$emit('checkOptions');

                if ( this.hasVariationsProduct )
                    this.canSendAjax = this.controllVariationProduct()
                else
                    this.canSendAjax = true;

                if ( this.optionsAreFilled && this.canSendAjax ) {
                    axios.post(this.route, {
                        id: this.productId,
                        quantity: this.quantity,
                        type: 'product'
                    }).then( response => {
                        if ( response.data.error ) {
                            let popup = document.createElement('div');
                            popup.innerHTML = response.data.popup;
                            document.getElementById('app').appendChild(popup);
                            this.addCloseListenerToPopup();
                        }
                        else {
                            this.$root.$emit('renderPopupProductAdded', response.data);
                            this.$root.$emit('calcBasketQuantity', response.data.quantity);
                        }
                    }).catch( error => console.log(error) )
                } else {
                    window.alert('Prosím zvoľte variáciu produktu.');
                    this.$root.$emit('optionsError');
                }
            },

            controllVariationProduct() { return this.productId != this.productIdProp; },

            addCloseListenerToPopup() {
                document.querySelector('.js-close-alert').addEventListener('click', function () {
                    document.getElementsByClassName('js-alert')[0].classList.add('hidden');
                });
            }
        },
    }
</script>
